import { call, fork, put, take } from "redux-saga/effects";
import { AppError, ErrorType } from "../../domain/model/app_error";
import { Customer } from "../../domain/model/customer";
import { JobCareer } from "../../domain/model/job_career";
import { PastCaseProject } from "../../domain/model/past_case_project";
import { User } from "../../domain/model/user";
import { IJobCareerRepository } from "../../domain/repository/job_career_repository";
import { IPastCaseProjectRepository } from "../../domain/repository/past_case_project_repository";
import { IUserRepository } from "../../domain/repository/user_repository";
import { createApiClient, IApiClient } from "../../infra/api/client";
import { createJobCareerAPI } from "../../infra/api/service/job_career_api";
import { createPastCaseProjectAPI } from "../../infra/api/service/past_case_project_api";
import { createUserAPI } from "../../infra/api/service/user_api";
import {
  createCustomerTopPageActionCreator,
  CustomerTopPageActionType,
  ICustomerTopPageActionCreator,
} from "../action/customer_top_page_action";
import { GetMeCustomerByCustomerTopPageResponse } from "../response/customer_response";
import { handleErrorForHandler } from "./handleErrorForHandler";

const apiClient: IApiClient = createApiClient();
const userRepository: IUserRepository = createUserAPI(apiClient);
const jobCareerRepository: IJobCareerRepository = createJobCareerAPI(apiClient);
const pastCaseProjectRepository: IPastCaseProjectRepository =
  createPastCaseProjectAPI(apiClient);
const actionCreator: ICustomerTopPageActionCreator =
  createCustomerTopPageActionCreator();

function* handleGetMeCustomerInCustomerTopPage() {
  while (true) {
    try {
      yield take(CustomerTopPageActionType.REQUEST_GET_ME_CUSTOMER_BY_TOP_PAGE);

      const user: User = yield call(getMeCustomer);
      if (user.customer) {
        const customer: Customer = user.customer;
        const email: string = user.email;
        customer.email = email;

        let jobCareers: JobCareer[] = [];
        let pastCaseProjects: PastCaseProject[] = [];

        jobCareers = yield call(getAllByCustomerJobCareer);
        pastCaseProjects = yield call(getAllByCustomerPastCaseProject);

        const res: GetMeCustomerByCustomerTopPageResponse =
          new GetMeCustomerByCustomerTopPageResponse();
        res.customer = customer;
        res.jobCareers = jobCareers;
        res.pastCaseProjects = pastCaseProjects;

        yield put(
          actionCreator.callbackGetMeCustomerByTopPageAction(true, res)
        );
      } else {
        throw new AppError(
          "UNKNOWN CODE",
          ErrorType.CLIENT_ERROR,
          "異常が発生しました"
        );
      }
    } catch (error) {
      yield fork(handleErrorForHandler, error);
      yield put(actionCreator.callbackGetMeCustomerByTopPageAction(false));
    }
  }
}

const getMeCustomer = () => {
  return userRepository.getMe();
};

const getAllByCustomerJobCareer = (): Promise<JobCareer[]> => {
  return jobCareerRepository.getAllByCustomer();
};

const getAllByCustomerPastCaseProject = (): Promise<PastCaseProject[]> => {
  return pastCaseProjectRepository.getAllByCustomer();
};

export { handleGetMeCustomerInCustomerTopPage };



// WEBPACK FOOTER //
// ./src/presentation/handler/customer_top_page_handler.ts